module.exports = __webpack_public_path__ + "img/1566241705.fb0b1441.jpg";